import request from "@/api/request";
import { VideoList } from "@/interfaces/Video/VideoList";
import { Video } from "@/interfaces/Video/Video";
import { PlaybackParams } from "@/interfaces/Video/PlaybackParams.ts";

class VideoService {
  static async getList(props: {
    page: number;
    order: string;
    tags: Array<number>;
    term: string;
    search_type: string | null;
  }): Promise<VideoList> {
    return request.get("/videos", props);
  }

  static async getVideo(id: number): Promise<Video> {
    return request.get(`/videos/${id}`);
  }

  static async playback(props: PlaybackParams): Promise<void> {
    return request.post("/videos/playback", props);
  }

  static async getUnlockedVideos(): Promise<Array<number>> {
    return request.get("/videos/unlocked");
  }

  static async setUnlockedVideos(token: string): Promise<Video[]> {
    return request.post("/videos/unlocked", { token });
  }

  static async getPlaybackData(id: number): Promise<Record<number, Record<number, number>>> {
    return request.get(`/videos/playbacks/${id}`);
  }

  static async getRandom(): Promise<Video> {
    return request.get("/videos/random");
  }
}

export default VideoService;
